import { useState } from 'react'
import { Stack } from '@chakra-ui/react'

import { CustomFormValidateField } from 'components/tools/CustomForm/types'
import { FormItem, MaskedInput } from 'components'
import { pisMask } from 'utils/masks'
import { validatePIS } from 'utils/validation/validators'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'
import useSetDefaultValueOnNotArrayData from '../../hooks/useSetDefaultValueOnNotArrayData'

export default function DefaultValuePIS({ formMethods, question }: DefaultValueCommonProps) {
  const [isFieldValid, setIsFieldValid] = useState<CustomFormValidateField>({
    isValid: true,
    message: '',
  })

  const handleValidatePIS = (pis: string): boolean => {
    let initialValue = { isValid: true, message: '' }

    if (pis && !validatePIS(pis)) {
      initialValue = { isValid: false, message: 'PIS está errado' }
    }

    setIsFieldValid(initialValue)
    return initialValue.isValid
  }

  useUnregisterDefaultValueField({ formMethods })

  useSetDefaultValueOnNotArrayData({ formMethods, question })

  return (
    <Stack>
      <FormItem label="Valor inicial">
        <MaskedInput
          mask={pisMask}
          {...formMethods.register('default_value', {
            validate: handleValidatePIS,
          })}
        />
      </FormItem>

      <CustomFormFieldErrorMessage {...isFieldValid} />
    </Stack>
  )
}
